export default __webpack_public_path__ + "static/media/customer-1.c0d0bcce.png";